import React from "react";

// css
import "./Team.css";

// assets
import arrowImg from "../../assets/images/arrow-forward.png";

const TeamCard = (props) => {
  const { imgSrc, shouldHover, name, title, setBioName } = props;
  return (
    <>
      <div
        className={
          shouldHover
            ? "pointer leadership-leader-card-wrapper grid grid-cols-[145px_auto] relative"
            : "leadership-leader-card-wrapper grid grid-cols-[145px_auto] relative"
        }
        onClick={setBioName}
      >
        <img
          src={imgSrc}
          alt={name}
          className="team-card-photo"
          style={{ display: "block" }}
        />
        <div className="card-content-padding">
          <div className="flex flex-col justify-between h-full">
            <div>
              <h4>{name}</h4>
              <h6>{title}</h6>
            </div>
              <img src={arrowImg} alt="" className="w-9 absolute bottom-2 right-2"/>
          </div>
        </div>
      </div>
    </>
  );
};

export default TeamCard;
